/**
 * The org code that is used when coming from `https://embracepetinsurance.com/partners/employer-discount
 * This is for partners that do not have branded QE experiences
 */
export const GENERIC_PARTNER_ORG_CODE: string = `80243102`;
